import {
    Box,
    Card,
    Center,
    Stack,
    Title
} from "@mantine/core";
import {FlexiSignInButton} from "@flexinet/ui-components";
import {signInWithRedirect, signOut} from "aws-amplify/auth";

const handleSignIn = async () => {
    try {
        await signOut();
    } catch {
        // ignore — no active session
    }
    await signInWithRedirect();
};
import classes from "./MarketingComponent.module.css";

export const MarketingComponent = () => {

    return (
        <Box className={classes.heroImage}>
            <Center h="100%">
                <Card shadow="xl" padding="xl" radius="md" withBorder
                      style={{
                          backgroundColor: 'rgba(255, 255, 255, 0.92)',
                          minWidth: 350
                      }}>
                    <Stack align="center" gap="lg">
                        <Title order={2}>Welcome to Flexi Network</Title>
                        <FlexiSignInButton
                            onClick={handleSignIn}>Sign in</FlexiSignInButton>
                    </Stack>
                </Card>
            </Center>
        </Box>
    )

}
